module.exports = __webpack_public_path__ + "img/兔子收纳盒-1.b9156fef.jpg";